import { AotCategory } from '../../utils/Constants';
import { Logger } from '../Logger';
import {
	CredentialTypeEnumeration,
	LabelTypeEnumeration,
	ResultEnumerationData,
} from './Definitions';

export default class FormsGenerator {
	public getFormXML(
		result: ResultEnumerationData,
		cancelButtonText: string,
		requirementsXML: string,
		timeout: number
	): string {
		Logger.getInstance().writeAot(
			AotCategory.Info,
			`Generating login form for authentication`
		);
		const cancelButtonXML = cancelButtonText
			? ''
			: `<CancelButtonText>${cancelButtonText}</CancelButtonText>`;

		let timeoutXML = '';
		if (timeout > 0) {
			timeoutXML = `<Timeout>${timeout}</Timeout>`;
		}

		return `<?xml version=\"1.0\" encoding=\"UTF-8\"?><AuthenticateResponse xmlns=\"http://citrix.com/authentication/response/1\"><Status>success</Status><Result>${result}</Result><StateContext/><AuthenticationRequirements><PostBack>/dummy</PostBack>${cancelButtonXML}${timeoutXML}<Requirements>${requirementsXML}</Requirements></AuthenticationRequirements></AuthenticateResponse>`;
	}

	public getMessageXML(labelType: LabelTypeEnumeration, message: string): string {
		return `<Requirement><Credential><Type>${CredentialTypeEnumeration.None}</Type></Credential><Label><Text>${message}</Text><Type>${labelType}</Type></Label><Input /></Requirement>`;
	}

	public getHeadingXML(heading: string): string {
		return this.getMessageXML(LabelTypeEnumeration.Heading, heading);
	}

	public getButtonXML(buttonId: string, buttonText: string): string {
		return `<Requirement><Credential><ID>${buttonId}</ID><Type>${CredentialTypeEnumeration.None}</Type></Credential><Label><Type/></Label><Input><Button>${buttonText}</Button></Input></Requirement>`;
	}

	public getUsernameXML(
		usernameId: string,
		usernameText: string,
		initialValue: string,
		readOnly = false
	): string {
		return `<Requirement><Credential><ID>${usernameId}</ID><Type>${CredentialTypeEnumeration.Username}</Type></Credential><Label><Text>${usernameText}</Text><Type>${LabelTypeEnumeration.Plain}</Type></Label><Input><Text><InitialValue>${initialValue}</InitialValue><ReadOnly>${readOnly}</ReadOnly></Text></Input></Requirement>`;
	}

	public getPasswordXML(passwordId: string, passwordText: string): string {
		return `<Requirement><Credential><ID>${passwordId}</ID><Type>${CredentialTypeEnumeration.Password}</Type></Credential><Label><Text>${passwordText}</Text><Type>${LabelTypeEnumeration.Plain}</Type></Label><Input><Text><Secret>true</Secret></Text></Input></Requirement>`;
	}

	public getPasscodeXML(passcodeId: string, passcodeText: string): string {
		return `<Requirement><Credential><ID>${passcodeId}</ID><Type>${CredentialTypeEnumeration.Passcode}</Type></Credential><Label><Text>${passcodeText}</Text><Type>${LabelTypeEnumeration.Plain}</Type></Label><Input><Text><Secret>true</Secret></Text></Input></Requirement>`;
	}

	public getTextCredentialXML(credentialId: string, credentialText: string): string {
		return `<Requirement><Credential><ID>${credentialId}</ID><Type>${CredentialTypeEnumeration.TextCredential}</Type></Credential><Label><Text>${credentialText}</Text><Type>${LabelTypeEnumeration.Plain}</Type></Label><Input><Text><Secret>true</Secret></Text></Input></Requirement>`;
	}
}
